// extracted by mini-css-extract-plugin
export default {"mCard":"SC-z","image":"TC-z","imageNoBackground":"UC-z","imageHasCategory":"VC-z","fullWidth":"WC-z"};